"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchClientStatTourViewThunk = exports.deleteUserThunk = exports.fetchClientThunk = exports.fetchClientsThunk = void 0;
const axios_1 = __importDefault(require("src/utils/axios"));
const actions_1 = require("./actions");
const actions_2 = require("../loader/actions");
const fetchClientsThunk = (filter) => (dispatch) => {
    dispatch((0, actions_2.setLoading)(true));
    axios_1.default
        .get("/api/v1/app/visitors/", { params: filter })
        .then((res) => {
        dispatch((0, actions_1.setClientsPage)({ current_page: res.data.current_page, count: res.data.count, page_size: res.data.page_size }));
        dispatch((0, actions_1.setClients)(res.data.results));
    })
        .catch((err) => {
        if (err.response.status == 404) {
            dispatch((0, actions_1.setClientsFilter)({ page: null }));
        }
        else {
            console.log(err);
        }
    })
        .finally(() => dispatch((0, actions_2.setLoading)(false)));
};
exports.fetchClientsThunk = fetchClientsThunk;
const fetchClientThunk = (id, setNotFound) => (dispatch) => {
    dispatch((0, actions_2.setLoading)(true));
    axios_1.default
        .get(`/api/v1/app/visitors/${id}/`)
        .then((res) => {
        dispatch((0, actions_1.setClient)(res.data));
    })
        .catch((err) => {
        console.log(err);
        setNotFound(true);
    })
        .finally(() => dispatch((0, actions_2.setLoading)(false)));
};
exports.fetchClientThunk = fetchClientThunk;
const deleteUserThunk = (id, successCb) => (dispatch) => {
    dispatch((0, actions_2.setLoading)(true));
    axios_1.default
        .post(`/api/v1/app/visitors/${id}/delete/`)
        .then(() => {
        successCb();
    })
        .catch(console.log)
        .finally(() => {
        dispatch((0, actions_2.setLoading)(false));
    });
};
exports.deleteUserThunk = deleteUserThunk;
const fetchClientStatTourViewThunk = (id) => (dispatch) => {
    dispatch((0, actions_2.setLoading)(true));
    axios_1.default
        .get("/api/v1/app/stat/tour/log/", { params: { visitor: id } })
        .then((res) => {
        dispatch((0, actions_1.setClientStatTourView)(res.data));
    })
        .catch(console.log)
        .finally(() => dispatch((0, actions_2.setLoading)(false)));
};
exports.fetchClientStatTourViewThunk = fetchClientStatTourViewThunk;
